exports.APPLICATION_ID = process.env.APPLICATION_ID
exports.SECURITY_API_URL = process.env.SECURITY_API_URL
exports.SECURITY_API_PRIVATE_KEY = process.env.SECURITY_API_PRIVATE_KEY
exports.CLIENT_API_URL = process.env.USERS_API_URL
exports.APPLICATION_DOMAIN =
  process.env.APPLICATION_DOMAIN || '.importgenius.com'
